import Timeline from '../components/timeline'

class Timelines {
	components: Timeline[] = []

	init(container: Document | HTMLElement = document): void {
		container.querySelectorAll<HTMLElement>('.hg-timeline').forEach((el) => {
			const component = new Timeline(el)
			component.init()
			this.components.push(component)
		})
	}

	update(container: Document | HTMLElement = document): void {
		this.cleanup()
		this.init(container)
	}

	cleanup(): void {
		this.components.forEach((c) => c.cleanup())
		this.components = []
	}
}

export default new Timelines()
